module.exports = __webpack_public_path__ + "img/Weapon_210.4d519d54.png";